<template>
    <section class="faq">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <script v-html="jsonLD" type="application/ld+json" />
        <div class="container">
            <h2 class="section-heading">
                {{ $t('heading') }}
            </h2>
            <ul
                aria-multiselectable="true"
                class="list-unstyled"
                id="accordion"
                role="tablist"
            >
                <li class="faq-item mb-2" v-for="(item, i) in items" :key="i">
                    <div class="faq-item__question flex">
                        <i class="faq-item__question__icon icon-question-mark" />
                        <p class="faq-item__question__content mb-0 mx-3">
                            {{ item.question }}
                        </p>
                    </div>
                    <div class="faq-item__answer">
                        <div
                            :aria-labelledby="`answer-${i}`"
                            class="collapse"
                            :id="`collapse-${i}`"
                            role="tabpanel"
                        >
                            <div class="faq-item__answer__content p-3 pb-2">
                                <!-- eslint-disable vue/no-v-html -->
                                <div v-html="item.answer" class="mb-2" />
                                <!-- eslint-enable vue/no-v-html -->
                                <ul v-if="item.links.length" class="mb-2">
                                    <li v-for="(link, j) in item.links" :key="j">
                                        <a :href="link.address" :rel="link.rel" :target="link.target">
                                            {{ link.text }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="faq-item__button text-center" :id="`answer-${i}`" role="tab">
                        <a
                            :aria-controls="`collapse-${i}`"
                            aria-expanded="false"
                            :data-parent="`#accordion`"
                            data-toggle="collapse"
                            :href="`#collapse-${i}`"
                            class="flex"
                        >
                            <p v-if="$device.mobile" class="mb-0 ml-2">پاسخ</p>
                            <i class="icon-arrow-down-12 show-answer" />
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>

export default {
    data () {
        return {
            items: Object.values(this.$t('content')),
        };
    },

    computed: {
        jsonLD () {
            const schema = {
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: [],
            };
            Object.values(this.$t('content')).forEach(item => {
                schema.mainEntity.push({
                    '@type': 'Question',
                    name: item.question,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: item.answer,
                    },
                });
            });
            return JSON.stringify(schema);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~vars';
@import 'assets/styles/mixins/shadow';

.faq {
    padding: 60px 0 40px;

    ul {
        margin-bottom: 0;
    }

    .faq-item {
        border-radius: 3px;
        @include shadow(1);
        background-color: $snow-white;

        &__question {
            padding: 15px 9px 0;
            border-bottom: 1px solid $gray-lighter;
            align-items: center;

            &__icon {
                font-size: 35px;
                color: $orange;
            }

            &__content {
                color: $gray-darker;
            }
        }

        &__answer {

            &__content {
                color: $gray-darker;
            }
        }

        &__button {
            background-color: $gray-light;

            a {
                color: $gray-darker;
                justify-content: center;
                align-items: center;

                i {
                    transition: transform 0.5s ease;
                    color: $gray;
                }

                &[ aria-expanded = 'true' ] {

                    i {
                        transform: rotateZ(180deg);
                    }
                }
            }
        }
    }
}

@media (min-width: 992px) {

    .faq {

        .faq-item {
            position: relative;

            &__answer {
                z-index: 2;
            }

            &__question {
                padding: 17px 20px;
            }

            &__button {
                background: none;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;

                a {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    height: 70px;

                    .show-answer {
                        position: absolute;
                        left: 20px;
                        top: 28px;
                    }
                }
            }
        }
    }
}
</style>

<i18n>
{
    "fa": {
        "heading": "پرسش‌های شما",
        "content": [
            {
                "question": "آیا نیاز به خرید بلیط اتوبوس برای کودکان و اطفال زیر ۲ سال هم وجود دارد؟",
                "answer": "بلیط اتوبوس افراد زیر دو سال در صورتی که صندلی به آن‌ها تعلق نگیرد رایگان است ولی در صورتی که نیاز به استفاده از صندلی داشته باشید، می‌بایست هزینه <a href='https://www.alibaba.ir/bus-ticket' target='_blank'>بلیط اتوبوس</a> را کامل پرداخت نمایید.",
                "links": []
            },
            {
                "question": "امکان حمل حیوانات خانگی در داخل اتوبوس وجود دارد؟",
                "answer": "طبق قوانین سازمان حمل‌ونقل امکان حمل حیوانات زنده در اتوبوس وجود ندارد.",
                "links": []
            },
            {
                "question": "مدارک مورد نیاز برای استفاده از اتوبوس چیست؟",
                "answer": "به همراه داشتن کارت شناسایی معتبر (کارت ملی یا شناسنامه) برای دریافت بلیط الزامی است.",
                "links": []
            },
            {
                "question": "آیا برای استفاده از اتوبوس نیاز به پرینت بلیط است؟",
                "answer": "برای استفاده از بلیط‌ اتوبوس، چاپ بلیط در دفتر تعاونی مربوطه با ارائه پیامک شماره بلیط و کارت شناسایی معتبر الزامی است.",
                "links": []
            },
            {
                "question": "جهت سوار شدن به اتوبوس چه مدت قبل از حرکت در ترمینال حضور داشته باشیم؟",
                "answer": "در صورتی که حرکت سرویس در ساعت مقرر انجام گردد مسافر می بایست حداکثر 30 دقیقه قبل حرکت سرویس در ترمینال مبدا حضور داشته باشد.",
                "links": []
            },
            {
                "question": "چگونه می‌توانم بلیط اتوبوسم را استرداد کنم؟",
                "answer": "در صورت قابل استرداد بودن بلیط خریداری شده، در «پنل کاربری» از منوی «سفارشات و استردادها»، سفارش مورد نظر را انتخاب کنید؛ بعد از کلیک بر روی گزینه استرداد و تکمیل مراحل، بلیط مورد نظر طبق قوانین و مقررات استرداد می‌شود.<br>هزینه‌ای که مسترد می‌شود به همان شماره حسابی واریز می‌شود که خرید انجام شده است. اگر لازم است که هزینه مسترد شده به حساب دیگری واریز گردد، باید با پشتیبانی تماس گرفته و آن‌ها را در جریان بگذارید.",
                "links": []
            },
            {
                "question": "میزان بار مجاز هر مسافر در سفر با اتوبوس چقدر است؟",
                "answer": "طبق قوانین سازمان حمل‌ونقل میزان بار مجاز 20 کیلوگرم است. البته برخی از تعاونی‌ها با دریافت هزینه، امکان حمل بار تا 40 کیلوگرم را نیز ارائه می‌دهند. همچنین یکی دیگر از مسائلی که در این زمینه باید مد نظر قرار بدهید، تعاونی اتوبوس شماست.<br>معمولا تعاونی ها، علاوه بر قوانین کلی میزان بار مجاز، قوانین خاص خودشان را دارند که در بعضی موارد، با قوانین تعاونی های دیگر فرق می‌کند. برای این که از میزان بار مجازتان مطمئن شوید و در حین سفر به مشکل برنخورید، به تعاونی که از آن بلیط تهیه کرده‌اید زنگ زده و از آن‌ها سوال کنید.<br>به این موضوع هم دقت کنید که اگر میزان بار اضافه شما بیش از حد باشد، متصدی اتوبوس ممکن است از گذاشتن آن‌ها در اتوبوس ممانعت کند. در این نوع مواقع می‌توانید در این مورد صحبت کنید که هزینه میزان بار اضافه‌تان را پرداخت کنید تا بتوانید همه وسیله‌هایتان را با خودتان حمل کنید.",
                "links": []
            }
        ]
    }
}
</i18n>
